import React from 'react';
import Banner from '../elements/Banner'
import ProfilePicture from '../elements/ProfilePicture'
import BusinessName from '../elements/BusinessName'
import Social from '../components/Social'
import About from '../elements/About'
import SaveAsContact from '../components/SaveAsContact';
import Accordions from '../components/Accordions'
import ImageSwiper from '../elements/ImageSwiper'
import ClientsSwiper from '../elements/ClientsSwiper'
import CallToAction from '../elements/CallToAction'
import Share from '../elements/Share'
import Title from '../elements/Title'
import Line from '../elements/Line'
// Import your image with the correct file path
import ImageSwiperCloser from '../elements/ImageSwiperCloser';

import { bgImageSrc, bannerImageSrc, bgVideoImageSrc, logoImageSrc, images } from '../media';

import PriceList from '../images/priceList.jpeg'
import LogoReal from '../images/logoImage.png'

const HomePage = () => {



    const divStyle = {
        backgroundImage: `url(${bgImageSrc})`, // Note the closing parenthesis
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };


    const divStyle1 = {
        backgroundImage: `url(${bgVideoImageSrc})`, // Note the closing parenthesis
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };

    return (
        <div className='bg-gray-100'>
            <div className='bg-white w-full md:w-5/6 lg:w-3/4 mx-auto shadow-2xl border-card_borderColor rounded-2xl ' >

                <div style={divStyle}>
                    <Banner
                        type="rectangle"
                        image={bannerImageSrc}
                    />

                    <ProfilePicture
                        type="circleBorder"
                        image={logoImageSrc}

                    />

                    <BusinessName
                        businessName="Oksana Freidin"
                        businessDescription="קוסמטיקה מתקדמת"
                    />

                    <div className='my-4 p-1 bg-transparent'></div>
                    <Social
                        phoneNumber="+972508859558"
                        phoneText="חייגו אליי"
                        whatsappNumber="+972508859558"
                        facebookUrl="https://www.facebook.com/oksana.fraidin?mibextid=ZbWKwL"
                        locationUrl="https://maps.app.goo.gl/vvksrr26XnQMaPo49"
                        wazeUrl=""
                        wazeText="נווטו לקליניקה"
                        instagramUsername="oksanafreidin"
                        tiktokUsername="oksifreidin"
                        shareUrl=""
                        type="circleBorder"

                    />


                    <SaveAsContact
                        text="שמרו אותי באנשי הקשר"
                        phoneNumber="+972508859558"
                        email="oksifreidin35@gmail.com"
                        firstName="Oksana Freidin"
                        lastName="קוסמטיקה מתקדמת"
                        type="rounded" />



                    <About
                        header="קצת עליי"
                        text=""
                        callToActionText="באווירה נעימה, פרטית ויחס אישי"
                    />



                    <div style={divStyle1} className="my-8 py-8 bg-gradient-to-l from-mainRing to-secondaryRing p-4 rounded-3xl flex flex-col items-center justify-center">
                        <div data-aos="fade-zoom-in" data-aos-easing="linear" className='mt-8 text-3xl font-bold text-center text-black'>סרטונים מהקליניקה </div>
                        <div data-aos="fade-zoom-in" data-aos-easing="linear" className="h-[1px] w-[260px] mx-auto mt-4 bg-black"></div>
                        <div className='flex flex-col md:flex-row items-center justify-around    w-full'>

                            <div>


                                {/* <div data-aos="fade-zoom-in" data-aos-easing="linear" className='mt-8 text-xl font-bold text-center text-black'>טיפול פנים</div> */}

                                <iframe
                                    src="https://player.vimeo.com/video/1018056551?h=57bf504263"
                                    width=""

                                    height="550"
                                    frameborder="0"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                    style={{ borderRadius: '32px' }}
                                    className='my-8 border-2'
                                ></iframe>
                            </div>


                            <div>


                                {/* <div data-aos="fade-zoom-in" data-aos-easing="linear" className='mt-8 text-xl font-bold text-center text-black'>דירה לדוגמה - שפיר מגורים</div> */}
                                <iframe
                                    src="https://player.vimeo.com/video/1018057119?h=cad79c576a"
                                    width=""

                                    height="550"
                                    frameborder="0"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                    style={{ borderRadius: '32px' }}
                                    className='my-8 border-2'
                                ></iframe>
                            </div>
                        </div>
                    </div>


                    <div className='max-w-[500px] p-8 mx-auto'>
                        <img className=' mx-auto my-12 shadow-2xl  border-8 border-white ' src={PriceList} alt="" />
                    </div>


                    <Accordions
                        header="טיפולים בקליניקה"
                        listItems={[
                            'טיפולי פנים',
                            'טיפולי גבות',
                            'ניקוי פנים עמוק',
                            "חידוש עור, אנטי אייג'ינג",
                            'טיפולי יופי',
                            'טיפול לידיים',
                            'טיפולי עיניים',
                            'עיסוי פנים',
                            'סדרת עיסויי פנים',
                        



                        ]}


                        headerContact="תקשורת ושעות פעילות"
                        phoneNumber="+972508859558"
                        email="oksifreidin35@gmail.com"
                        activityHours={[
                            { text: "ימים ראשון עד שבת", hours: "09:00 - 18:00" },

                        ]}
                        adressUrl="https://maps.app.goo.gl/vvksrr26XnQMaPo49"
                        adressText="יצחק טבנקין 31, דירה 5, נווה שאנן"
                        type="rounded" />

                </div>

                <div style={divStyle}>
                    <ImageSwiperCloser
                        type="top"
                        images={images} />
                    <ImageSwiper
                        images={images}
                        type="rounded"
                    />
                    <ImageSwiperCloser
                        type="bottom"
                        images={images} />
                </div>


                <div style={divStyle}>
                    <Title
                        text="לקוחות ממליצים" />

                    <ClientsSwiper
                        testimonials={[
                            {
                                "text": "אני לא יכולה להיות יותר ממרוצה מהטיפול המדהים שקיבלתי! אוקסנה הפתיעה אותי במקצועיות, נדיבות וידע. היא הקשיבה לצרכים שלי, המליצה על מוצרים שמתאימים במיוחד לעור שלי, והתוצאה היא פשוט מדהימה! תודה רבה, אני בוודאי אחזור שוב לטיפולים נוספים אצלה.",
                                "author": "אלכס פוספלוב, ספרית"
                            },
                            {
                                "text": "אין לי מילים לתאר כמה אני מרוצה מהטיפול המדהים שלך! הידע שלך בתחום הקוסמטיקה בלתי רגיל, והטיפול שקיבלתי היה פשוט מעולה. הכיף וההנאה שהעברת לי בזמן הטיפול הם לא רק מרגשים, אלא גם מרגשים. אני מודה לך מקרב לב על השירות המדהים, ואני מרגישה חזק כי אני חייבת לחזור שוב בהקדם האפשרי!",
                                "author": "סבטלנה קוזנצקי, אחות בבית חולים"
                            },
                            {
                                "text": "Оксана! Спасибо огромное за процедуры, было очень классно, ты большой специалист. Все средства подобраны профессионально, качественно, не было ни аллергии, ни раздражений. Рекомендую!!!",
                                "author": "ילנה גברילנקו, כוח עזר בית חולים"
                            },
                            {
                                "text": "Привет , спасибо огромное , даже у такого скептика, просто восторг , никакого раздражения и даже сегодня гладкое как …. младенца.",
                                "author": "מנהלת חשבונות בחברה, חיפה"
                            },
                            {
                                "text": "היי, מה שלומך רציתי להגיד לך תודה על המוצרים השתמשתי בהם היום והעור כבר מרגיש אחרת (אצלי רואים ישר אם אני עושה טוב או רע לעור הפנים /לגוף ). בכל מקרה, תודה רבה והריח של החומצה אזלאית פשוט מהמם 😍 והפילינג מהמם 🤩 ישר החליק את עור הפנים",
                                "author": "נסרין, אם לתינוק"
                            },
                            {
                                "text": "הי אוקסנה! מאוד מודע לך על הטיפול המדהים💥 העור נראה זוהר וקורן, הרגשה מאוד טובה מהעיסוי שלך. התחלתי להשתמש במוצרים לפי המלצה שלך, הכול טוב. סוף שבוע נעים, נפגש שוב לפני החגים🌸",
                                "author": "אירנה קולומיסקי, תפקיד ניהולי בבית חולים"
                            }

                        ]}
                    />

                    {/* <Line /> */}

                    {/* <div data-aos="fade-zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="800">
                        <h1 dir='rtl' className='text-center px-6 max-w-[600px] mx-auto'>
                            שלום לכם לקוחות יקרים! התחלתי לעבוד עם שירות לקביעת תורים, מעכשיו תוכלו להזמין אצלי תורים בפשטות ובקלות. הורידו את האפליקציה בכפתור למטה, הירשמו וחפשו לפי קוד העסק:
                            <br />
                            <span className='font-bold'> 25670</span>
                        </h1>

                    </div> */}
                    {/* <div className='shake-animation  max-w-[300px] mx-auto'>


                        <a
                            href="https://point-app.net/download/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group hover:shadow-lg hover:shadow-[#f5cec8]/60 transition ease-in-out hover:scale-105 p-1 rounded-xl bg-gradient-to-br from-[#000] via-[#333] to-[#000] hover:from-[#333] hover:via-[#000] hover:to-[#333] max-w-[300px] mx-auto flex flex-col justify-around items-center text-center border-2 border-[#f5cec8] dir-rtl"
                        >
                            <div className="px-6 py-2 backdrop-blur-xl bg-gradient-to-tr from-black to-[#333] rounded-xl font-bold h-full">
                                <span className="block text-lg mb-1 font-semibold text-[#fff] group-hover:text-[#f5cec8]">
                                    לקביעת תור דרך האפליקציה לחצי כאן
                                </span>
                                <span className="block text-lg mb-1 font-semibold text-[#f5cec8]">
                                    קוד עסק 25670
                                </span>
                                <svg
                                    className="w-6 h-6 stroke-[#f5cec8] group-hover:stroke-[#fff]"
                                    strokeWidth="1.8"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                        strokeLinejoin="round"
                                        strokeLinecap="round"
                                    ></path>
                                </svg>
                            </div>
                        </a>

                    </div> */}

                    <div data-aos="fade-down"
                        data-aos-easing="ease-in-out">
                        <Line />

                        <CallToAction
                            header="לייעוץ ופרטים נוספים לחצו על הלוגו"
                            phoneNumber="+972508859558"
                            contact="whatsapp"
                            type="circleBorder"
                            image={LogoReal} />

                        <Line />
                    </div>


                    <Share
                        url="https://oksicosmetics.netlify.app/"
                        type="circleBorder"
                    />
                </div>

            </div>
        </div>

    )
}

export default HomePage